import React from 'react';
import { Box, Button, Paper, Tab, Tabs, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hook/store';
import { ESliceAuth } from '../../store/slices/authSlice';
import { billingWorkspaceHref, billingWorkspaceSection, billingWorkspaceSections, canReadBillingSection } from './billingWorkspaceNavigation';

/** Keep each route's existing permission code and screen; only the shared navigation is new. */
const BillingWorkspace: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname, search } = useLocation();
  const permissions = useAppSelector(state => state[ESliceAuth.AuthInfo].permission) || [];
  const sections = billingWorkspaceSections.filter(section => canReadBillingSection(permissions, section.code));
  const active = billingWorkspaceSection(pathname);
  // The app shell is a fixed-height flex column. Keep this workspace in normal
  // document flow so long page content cannot shrink and clip the navigation.
  return <Box sx={{ minWidth: 0, flexShrink: 0 }}>
    <Paper component="nav" aria-label="ศูนย์วางบิลและเอกสาร" variant="outlined"
      sx={{ mb: 2, overflow: 'hidden', flexShrink: 0 }}>
      <Box sx={{ px: 2, py: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Box sx={{ flex: '1 1 240px', minWidth: 0 }}>
          <Typography variant="h6">ศูนย์วางบิลและเอกสาร</Typography>
          <Typography variant="body2" color="text.secondary">วางบิลหลังส่งสินค้า • e-Tax หลังยืนยัน Invoice</Typography>
        </Box>
        {canReadBillingSection(permissions, '02-06') && pathname !== '/sales/billing' &&
          <Button component={Link} to="/sales/billing" size="small">รอบบิลทั้งหมด</Button>}
      </Box>
      <Tabs value={sections.some(section => section.id === active) ? active : false}
        variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="งานวางบิลและเอกสาร"
        sx={{ borderTop: 1, borderColor: 'divider', minHeight: 48,
          '& .MuiTab-root': { minHeight: 48, flexShrink: 0, whiteSpace: 'nowrap' } }}>
        {sections.map(section => <Tab key={section.id} value={section.id} label={section.label}
          component={Link} to={billingWorkspaceHref(section.id, search)} />)}
      </Tabs>
    </Paper>
    <Box sx={{ minWidth: 0 }}>{children}</Box>
  </Box>;
};

export default BillingWorkspace;
